import type * as React from 'react';

import { VitaDocumentThemeTemplate } from '@xing-com/crate-common-graphql-types';
import { TemplateGlobalStyles } from '@xing-com/crate-lebenslauf-components';
import {
  useIsCoverLetterEditor,
  useReadCoverLetter,
  useReadVitaReactiveVariable,
} from '@xing-com/crate-lebenslauf-hooks';

import { Business } from './business';
import { CoverLetterTraditional } from './cover-letter-traditional';
import { Creative } from './creative';
import { Elegant } from './elegant';
import { Frame } from './frame';
import { Modern } from './modern';
import { Timeline } from './timeline';
import { Traditional } from './traditional';

export type {
  TemplateCreativeProps,
  TemplateCreativeXinglet,
} from './creative';
export type { TemplateModernProps, TemplateModernXinglet } from './modern';
export type {
  TemplateTraditionalProps,
  TemplateTraditionalXinglet,
} from './traditional';
export type { TemplateFrameProps, TemplateFrameXinglet } from './frame';
export type {
  TemplateTimelineProps,
  TemplateTimelineXinglet,
} from './timeline';
export type { TemplateElegantProps, TemplateElegantXinglet } from './elegant';
export type {
  TemplateBusinessProps,
  TemplateBusinessXinglet,
} from './business';
export type {
  TemplateCoverLetterTraditionalProps,
  TemplateCoverLetterTraditionalXinglet,
} from './cover-letter-traditional';

export type TemplateProps = {
  className?: string;
  pageVisible?: number;
  setTotalPages?: (total: number) => void;
};

export const Template: React.VFC<TemplateProps> = (props) => {
  const { theme } = useReadVitaReactiveVariable();
  const coverLetter = useReadCoverLetter();
  const isCoverLetterEditor = useIsCoverLetterEditor();

  const template = isCoverLetterEditor
    ? coverLetter.theme?.template
    : theme?.template;

  switch (template) {
    case VitaDocumentThemeTemplate.Creative: {
      return (
        <>
          <TemplateGlobalStyles />
          <Creative {...props} />
        </>
      );
    }

    case VitaDocumentThemeTemplate.Traditional: {
      return (
        <>
          <TemplateGlobalStyles />
          <Traditional {...props} />
        </>
      );
    }

    case VitaDocumentThemeTemplate.Modern: {
      return (
        <>
          <TemplateGlobalStyles />
          <Modern {...props} />
        </>
      );
    }

    case VitaDocumentThemeTemplate.Frame: {
      return (
        <>
          <TemplateGlobalStyles />
          <Frame {...props} />
        </>
      );
    }

    case VitaDocumentThemeTemplate.Timeline: {
      return (
        <>
          <TemplateGlobalStyles />
          <Timeline {...props} />
        </>
      );
    }

    case VitaDocumentThemeTemplate.Elegant: {
      return (
        <>
          <TemplateGlobalStyles />
          <Elegant {...props} />
        </>
      );
    }

    case VitaDocumentThemeTemplate.Business: {
      return (
        <>
          <TemplateGlobalStyles />
          <Business {...props} />
        </>
      );
    }

    case VitaDocumentThemeTemplate.TraditionalCoverLetter: {
      return (
        <>
          <TemplateGlobalStyles />
          <CoverLetterTraditional {...props} />
        </>
      );
    }

    default:
      return null;
  }
};
